module.exports = __webpack_public_path__ + "static/image/history/pc/202601_2.ver2_0_2.jpg?65568eb1";